import { callBffApi } from "../../services/axios";
import { IUserAdditionalInfo, UiConfig } from "./redux";

export const fetchUiConfigs = async () =>
  callBffApi<UiConfig>("get", "/ui-configs");

export const fetchUserAdditionalInfo = () =>
  callBffApi<IUserAdditionalInfo>("get", "/user");
